export default {
      id: "videomeeting-mic-on-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#videomeeting-mic-on",
      toString: function () {
        return this.url;
      }
    }